<script lang="ts" module>
	export const symbolId = "ishavskraft-icon-outlined-checkmark";
	export const symbol = `
		<symbol id="${symbolId}" viewBox="0 0 20 20">
			<path
				d="M8.6 11.8L6.425 9.625C6.24167 9.44167 6.01233 9.354 5.737 9.362C5.46167 9.37 5.23267 9.466 5.05 9.65C4.86667 9.83333 4.775 10.0667 4.775 10.35C4.775 10.6333 4.86667 10.8667 5.05 11.05L7.9 13.9C8.08333 14.0833 8.31667 14.175 8.6 14.175C8.88333 14.175 9.11667 14.0833 9.3 13.9L14.975 8.225C15.1583 8.04167 15.246 7.81233 15.238 7.537C15.23 7.26167 15.134 7.03267 14.95 6.85C14.7667 6.66667 14.5333 6.575 14.25 6.575C13.9667 6.575 13.7333 6.66667 13.55 6.85L8.6 11.8ZM10 20C8.61667 20 7.31667 19.7373 6.1 19.212C4.88333 18.6867 3.825 17.9743 2.925 17.075C2.025 16.175 1.31267 15.1167 0.788 13.9C0.263333 12.6833 0.000666667 11.3833 0 10C0 8.61667 0.262667 7.31667 0.788 6.1C1.31333 4.88333 2.02567 3.825 2.925 2.925C3.825 2.025 4.88333 1.31267 6.1 0.788C7.31667 0.263333 8.61667 0.000666667 10 0C11.3833 0 12.6833 0.262667 13.9 0.788C15.1167 1.31333 16.175 2.02567 17.075 2.925C17.975 3.825 18.6877 4.88333 19.213 6.1C19.7383 7.31667 20.0007 8.61667 20 10C20 11.3833 19.7373 12.6833 19.212 13.9C18.6867 15.1167 17.9743 16.175 17.075 17.075C16.175 17.975 15.1167 18.6877 13.9 19.213C12.6833 19.7383 11.3833 20.0007 10 20ZM10 18C12.2167 18 14.1043 17.221 15.663 15.663C17.2217 14.105 18.0007 12.2173 18 10C18 7.78333 17.221 5.89567 15.663 4.337C14.105 2.77833 12.2173 1.99933 10 2C7.78333 2 5.89567 2.779 4.337 4.337C2.77833 5.895 1.99933 7.78267 2 10C2 12.2167 2.779 14.1043 4.337 15.663C5.895 17.2217 7.78267 18.0007 10 18Z"
			/>
		</symbol>`;
</script>

<script lang="ts">
	import type { ClassValue } from "svelte/elements";

	let {
		class: classes = null,
		ariaHidden = true,
	}: {
		class?: ClassValue | null;
		ariaHidden?: boolean;
	} = $props();
</script>

<svg
	aria-hidden={ariaHidden}
	width="24"
	height="24"
	viewBox="0 0 20 20"
	xmlns="http://www.w3.org/2000/svg"
	class={classes}
	fill="currentColor"
>
	<use href="#{symbolId}" />
</svg>
